import { render } from "./Landing.vue?vue&type=template&id=77cda7a8&scoped=true"
import script from "./Landing.vue?vue&type=script&lang=js"
export * from "./Landing.vue?vue&type=script&lang=js"

import "./Landing.vue?vue&type=style&index=0&id=77cda7a8&scoped=true&lang=css"

import exportComponent from "/Users/edvinasjuck/PhpstormProjects/arunvilkasa.lt/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77cda7a8"]])

export default __exports__